'use strict';

const superZoom = require('../super-zoom');
const { gsap } = require("gsap");

let timeline = null;

const scrollAnimation = () => {
    killScrollAnimation();

    if (!$('body').hasClass('mobile') || superZoom.isActive || !$('.step__type--slidingRadioButtons').length) {
        return;
    }

    // Create the timeline for the scroll animation
    timeline = gsap.timeline({
        scrollTrigger: {
            markers: false,
            trigger: 'body.mobile .step__type--slidingRadioButtons .step__answers',
            scroller: 'body.mobile .step__type--slidingRadioButtons .step__answers_wrapper',
            start: 'start bottom-=70px', // 150px is the height of the visible scroll content
            end: '+=300',
            scrub: true,
        },
    });

    let title = '.step__type--slidingRadioButtons .step__title--xl';
    let background = '.step__type--slidingRadioButtons .step__background';
    timeline
        .to( title, { // Move title up
            y: '-40px',
            duration: 0.75,
        })
        .fromTo( title, // Hide title
            { autoAlpha: 1 },
            { autoAlpha: 0, duration: 0.5 },
            '>'
        )
        .fromTo(background, // Reduce the background opacity
            { opacity: 1, duration: 0.5 },
            { opacity: 0.7 },
            '<');
};

// Reset animation
const killScrollAnimation = () => {
    let slidingRadioButtons_Title = '.step__type--slidingRadioButtons .step__title--xl';
    $(slidingRadioButtons_Title).show();
    $(slidingRadioButtons_Title).css('transform', 'none');

    let slidingRadioButtons_Background = '.step__type--slidingRadioButtons .step__background';
    $(slidingRadioButtons_Background).css('opacity', '');

    if (timeline) {
        if (timeline.scrollTrigger) {
            timeline.scrollTrigger.kill();
        }

        timeline.kill();
    }
};

module.exports = {
    scrollAnimation
};
